import { NavSubItemViewModel } from '../nav-sub-item-view-model';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ProductGroupDomainModel } from '../../../../../../domainModels/product-group-domain-model';

@Injectable()
export class UniversalVariantsSubNavItemViewModel extends NavSubItemViewModel {
  constructor(
    private productGroupDomainModel: ProductGroupDomainModel,
    router: Router
  ) {
    super(router);
  }

  public showNavItemAlertIndicator$ = this.productGroupDomainModel.incompleteVariantCount$.pipe(
    map(incomplete => incomplete > 0)
  );
}
